var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "support_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#support_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14.4v-1.6c-1.56 0-2.882-.543-3.97-1.63C2.944 10.085 2.4 8.763 2.4 7.205c0-1.558.544-2.882 1.631-3.97C5.12 2.143 6.443 1.6 8.003 1.6c.78 0 1.508.147 2.183.442a5.699 5.699 0 0 1 1.772 1.2 5.695 5.695 0 0 1 1.2 1.772c.295.677.442 1.405.442 2.186 0 .767-.164 1.511-.492 2.233a8.601 8.601 0 0 1-1.283 2.017 11.264 11.264 0 0 1-1.792 1.692c-.666.505-1.344.925-2.033 1.258Zm1.2-2.133a10.334 10.334 0 0 0 2.267-2.325c.622-.884.933-1.798.933-2.742 0-1.211-.43-2.247-1.292-3.108C10.248 3.23 9.211 2.8 8 2.8s-2.247.43-3.108 1.292C4.03 4.952 3.6 5.989 3.6 7.2s.43 2.247 1.292 3.108C5.752 11.17 6.789 11.6 8 11.6h1.2v.667ZM8 10.4a.642.642 0 0 0 .471-.195.642.642 0 0 0 .196-.472.642.642 0 0 0-.196-.471A.642.642 0 0 0 8 9.067a.642.642 0 0 0-.472.195.642.642 0 0 0-.195.471c0 .185.065.342.195.472.13.13.288.195.472.195Zm-.483-2.033h.966c0-.29.022-.509.067-.659.044-.15.172-.33.383-.541.2-.19.4-.39.6-.6.2-.211.3-.511.3-.9 0-.534-.178-.945-.533-1.234C8.944 4.144 8.51 4 8 4c-.465 0-.857.133-1.174.4a2.104 2.104 0 0 0-.66.933l.873.367a1.32 1.32 0 0 1 .302-.533c.15-.167.37-.25.659-.25.3 0 .52.083.658.25a.82.82 0 0 1-.033 1.125c-.161.16-.336.33-.525.508-.289.267-.458.497-.508.692-.05.194-.075.486-.075.875Z",
    fill: "#404040"
  }))));
};
export default SvgSupport;